// @flow

import React, { useState } from 'react';
import type { Element } from 'react';

import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { withTranslation } from '@i18n';
import { Dialog } from '@components';

import ContactEmployerForm from './components/ContactEmployerForm';
import type { Props } from './types';
import {
  StyledWrapper,
  StyledDescriptionText,
  StyledDialogContent,
  StyledDialogHeader,
  StyledHeaderCloseIcon,
  StyledHeaderText,
  StyledThanksWrapper,
  StyledThanksTitle,
  StyledThanksText
} from './styles';

const ContactEmployerDialog = (props: Props): Element<any> => {
  const { isDialogOpen, hideDialog, t } = props;
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  const closeDialog = (): void => {
    hideDialog();
    setFormSubmitted(false);
  };

  if (!isDialogOpen) return <></>;

  const headerContent = <StyledHeaderText>{t('ContactEmployer.Title')}</StyledHeaderText>;
  const headerCloseButton = <StyledHeaderCloseIcon onClick={closeDialog} icon={faTimes} />;

  const dialogBody = formSubmitted ? (
    <StyledThanksWrapper>
      <StyledThanksTitle>{t('ContactEmployer.ThanksTitle')}</StyledThanksTitle>
      <StyledThanksText>{t('ContactEmployer.ThanksText')}</StyledThanksText>
    </StyledThanksWrapper>
  ) : (
    <>
      <StyledDescriptionText>{t('ContactEmployer.Subtitle')}</StyledDescriptionText>
      <ContactEmployerForm setFormSubmitted={setFormSubmitted} {...props} />
    </>
  );

  return (
    <Dialog size="LARGE">
      <StyledWrapper>
        <StyledDialogContent>
          <StyledDialogHeader
            renderCloseButton={headerCloseButton}
            renderHeaderContent={headerContent}
          />

          {dialogBody}
        </StyledDialogContent>
      </StyledWrapper>
    </Dialog>
  );
};

export default withTranslation('Hospitals')(ContactEmployerDialog);
